










































import { Component, Mixins } from "vue-property-decorator";
import TicketProvider from "@/components/app/global/tickets/ticketProvider.vue";
import Context from "@/mixins/context";
import { ClientRoutes } from "@/data/enums/router";

@Component({
  components: {
    "ticket-provider": () =>
      import("@/components/app/global/tickets/ticketProvider.vue"),
    "ticket-header": () =>
      import("@/components/app/global/tickets/ticketHeader.vue"),
    "ticket-feed": () =>
      import("@/components/app/global/tickets/ticketFeed.vue")
  }
})
export default class TicketModal extends Mixins(TicketProvider, Context) {
  // Computed

  public get ticketRoute() {
    return {
      name: this.isClient ? ClientRoutes.SUPPORT_TICKET : "adminSupportTicket",
      params: { ticketId: this.ticketId }
    };
  }
}
